module.exports = __webpack_public_path__ + "static/Synchronised-Development-Operations-68709d4c297ae1b820f474469c9a1ac3.svg";